// extracted by mini-css-extract-plugin
module.exports = {"type":"AnimalIdentification_type__1ARpU"};